export default __webpack_public_path__ + "static/media/Acast2022.dc640136.png";